import { render, staticRenderFns } from "./CreditScoreList.vue?vue&type=template&id=06763d34&scoped=true&"
import script from "./CreditScoreList.vue?vue&type=script&lang=js&"
export * from "./CreditScoreList.vue?vue&type=script&lang=js&"
import style0 from "./CreditScoreList.vue?vue&type=style&index=0&id=06763d34&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06763d34",
  null
  
)

export default component.exports